export default "__VITE_ASSET__BSLmOKl7__"